// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1Iujx","productName":"Table_productName__1RFZW"};